<audio
  #audioEl
  [src]="src()"
  [volume]="volume()"
  (timeupdate)="onTimeUpdate()"
  (loadedmetadata)="onLoadedMetadata()"
  (play)="onPlay()"
  (pause)="onPause()"
  (ended)="onEnded()"
></audio>

<odl-button
  variant="primary"
  size="small"
  class="audio-player-toggle"
  [id]="toggleId"
  [description]="(isPlaying() ? 'PAUSE' : 'PLAY') | translate"
  (click)="togglePlay()"
>
  <odl-icon [name]="isPlaying() ? 'pause' : 'play'" slot="only-icon"></odl-icon>
</odl-button>
<odl-tooltip placement="top" [attr.for]="'#' + toggleId">{{
  (isPlaying() ? 'PAUSE' : 'PLAY') | translate
}}</odl-tooltip>

<span class="audio-player-time">{{ formattedCurrentTime() }}</span>

<nr-range-slider
  class="audio-player-seek"
  [formControl]="seekControl"
  min="0"
  step="any"
  [max]="duration() || 0"
  [tooltipText]="formattedCurrentTime()"
/>

<span class="audio-player-time">{{ formattedDuration() }}</span>

<div class="audio-player-volume-group">
  <odl-button
    variant="text"
    size="small"
    class="audio-player-mute"
    [id]="muteId"
    [description]="(isMuted() ? 'QUESTIONS.UNMUTE' : 'QUESTIONS.MUTE') | translate"
    (click)="toggleMute()"
  >
    <odl-icon [name]="isMuted() ? 'volume_off' : 'volume_up'" slot="only-icon"></odl-icon>
  </odl-button>
  <odl-tooltip placement="top" [attr.for]="'#' + muteId">{{
    (isMuted() ? 'QUESTIONS.UNMUTE' : 'QUESTIONS.MUTE') | translate
  }}</odl-tooltip>

  <nr-range-slider
    class="audio-player-volume"
    [formControl]="volumeControl"
    min="0"
    max="100"
    [tooltipText]="volumeTooltipLabel()"
  />
</div>
